import { SourceType } from '../types/core'

export const sourceTypes: SourceType[] = [
  {
    name: 'Website',
    value: 'website',
    manual: false,
    apiAlias: 'website',
    title: 'a Website',
    id: 'website',
  },
  {
    name: 'Book',
    value: 'book',
    manual: false,
    apiAlias: 'book',
    title: 'a Book',
    id: 'book',
  },
  {
    name: 'Journal',
    value: 'journal',
    manual: false,
    apiAlias: 'journal',
    title: 'a Journal',
    id: 'journal',
  },
  {
    name: 'Newspaper',
    value: 'newspaper',
    manual: true,
    apiAlias: 'newspaper',
    title: 'a Newspaper',
    id: 'newspaper',
  },
  {
    name: 'Film/Online Video',
    value: 'film',
    manual: false,
    apiAlias: 'film',
    title: 'a Film',
    id: 'film',
  },
  {
    name: 'Online Database',
    value: 'online-database',
    manual: true,
    apiAlias: 'database',
    title: 'an Online Database',
    id: 'online-database',
  },
  {
    name: 'Advertisement',
    value: 'advertisement',
    manual: true,
    title: 'an Advertisement',
    apiAlias: 'advertisement',
    id: 'advertisement',
  },
  {
    name: 'Bible',
    value: 'bible',
    manual: false,
    title: 'a Bible',
    apiAlias: 'bible',
    id: 'bible',
  },
  {
    name: 'Blog',
    value: 'blog',
    manual: true,
    title: 'a Blog',
    apiAlias: 'blog',
    id: 'blog',
  },
  {
    name: 'Brochure',
    value: 'brochure',
    manual: true,
    title: 'a Brochure',
    apiAlias: 'brochure',
    id: 'brochure',
  },
  {
    name: 'Cartoon',
    value: 'cartoon',
    manual: true,
    title: 'a Cartoon',
    apiAlias: 'cartoon',
    id: 'cartoon',
  },
  {
    name: 'Chapter',
    value: 'chapter',
    manual: false,
    title: 'a Chapter',
    apiAlias: 'chapter',
    id: 'chapter',
  },
  {
    name: 'Conference',
    value: 'conference',
    manual: false,
    title: 'a Conference',
    apiAlias: 'conference',
    id: 'conference',
  },
  {
    name: 'Congress',
    value: 'congress',
    manual: false,
    title: 'a Congressional Publication',
    apiAlias: 'congress',
    id: 'congress',
  },
  {
    name: 'Court Case',
    value: 'court-case',
    manual: true,
    title: 'a Court Case',
    apiAlias: 'courtcase',
    id: 'court-case',
  },
  {
    name: 'Database',
    value: 'database',
    manual: true,
    title: 'a Database',
    apiAlias: 'database',
    id: 'database',
  },
  {
    name: 'Dictionary',
    value: 'dictionary',
    manual: false,
    title: 'a Dictionary',
    apiAlias: 'dictionary',
    id: 'dictionary',
  },
  {
    name: 'Digital File',
    value: 'digital',
    manual: true,
    title: 'a Digital File',
    apiAlias: 'digital',
    id: 'digital',
  },
  {
    name: 'Digital Image',
    value: 'image',
    manual: true,
    title: 'a Digital Image',
    apiAlias: 'image',
    id: 'image',
  },
  {
    name: 'Dissertation',
    value: 'dissertation',
    manual: false,
    title: 'a Dissertation',
    apiAlias: 'dissertation',
    id: 'dissertation',
  },
  {
    name: 'Dissertation Abstract',
    value: 'dissertation-abstract',
    manual: false,
    title: 'a Dissertation Abstract',
    apiAlias: 'dissertationabstract',
    id: 'dissertation-abstract',
  },
  {
    name: 'Editorial',
    value: 'editorial',
    manual: true,
    title: 'an Editorial',
    apiAlias: 'editorial',
    id: 'editorial',
  },
  {
    name: 'Email',
    value: 'email',
    manual: true,
    title: 'an Email',
    apiAlias: 'email',
    id: 'email',
  },
  {
    name: 'Encyclopedia',
    value: 'encyclopedia',
    manual: false,
    title: 'an Encyclopedia',
    apiAlias: 'encyclopedia',
    id: 'encyclopedia',
  },
  {
    name: 'Executive Order',
    value: 'executive-order',
    manual: true,
    title: 'an Executive Order',
    apiAlias: 'executiveorder',
    id: 'executive-order',
  },
  {
    name: 'Federal Bill',
    value: 'federal-bill',
    apiAlias: 'fedbill',
    manual: false,
    title: 'a Federal Bill',
    id: 'federal-bill',
  },
  {
    name: 'Federal Report',
    value: 'federal-report',
    apiAlias: 'fedreport',
    manual: true,
    title: 'a Federal Report',
    id: 'federal-report',
  },
  {
    name: 'Federal Rule',
    value: 'federal-rule',
    apiAlias: 'fedrule',
    manual: true,
    title: 'a Federal Rule',
    id: 'federal-rule',
  },
  {
    name: 'Federal Statute',
    value: 'federal-statute',
    apiAlias: 'statute',
    manual: true,
    title: 'a Federal Statute',
    id: 'federal-statute',
  },
  {
    name: 'Federal Testimony',
    value: 'federal-testimony',
    apiAlias: 'testimony',
    manual: true,
    title: 'Federal Testimony',
    id: 'federal-testimony',
  },
  {
    name: 'Government Publication',
    value: 'govt',
    manual: false,
    title: 'a Government Publication',
    apiAlias: 'govt',
    id: 'govt',
  },
  {
    name: 'Interview',
    value: 'interview',
    manual: true,
    title: 'an Interview',
    apiAlias: 'interview',
    id: 'interview',
  },
  {
    name: 'Introduction',
    value: 'introduction',
    manual: false,
    title: 'an Introduction',
    apiAlias: 'introduction',
    id: 'introduction',
  },
  {
    name: 'Lecture',
    value: 'lecture',
    manual: true,
    title: 'a Lecture',
    apiAlias: 'lecture',
    id: 'lecture',
  },
  {
    name: 'Letter',
    value: 'letter',
    manual: true,
    title: 'a Letter',
    apiAlias: 'letter',
    id: 'letter',
  },
  {
    name: 'Magazine',
    value: 'magazine',
    manual: true,
    title: 'a Magazine',
    apiAlias: 'magazine',
    id: 'magazine',
  },
  {
    name: 'Mailing List',
    value: 'mailing-list',
    manual: true,
    title: 'a Mailing List',
    apiAlias: 'mailinglist',
    id: 'mailing-list',
  },
  {
    name: 'Manuscript',
    value: 'manuscript',
    manual: true,
    title: 'a Manuscript',
    apiAlias: 'manuscript',
    id: 'manuscript',
  },
  {
    name: 'Map',
    value: 'map',
    manual: false,
    title: 'a Map',
    apiAlias: 'map',
    id: 'map',
  },
  {
    name: 'Microform',
    value: 'microform',
    manual: true,
    title: 'a Microform',
    apiAlias: 'microform',
    id: 'microform',
  },
  {
    name: 'Miscellaneous',
    value: 'miscellaneous',
    manual: true,
    title: 'a Miscellaneous Source',
    apiAlias: 'miscellaneous',
    id: 'miscellaneous',
  },
  {
    name: 'Multivolume',
    value: 'multivolume',
    manual: false,
    title: 'a Multivolume Source',
    apiAlias: 'multivolume',
    id: 'multivolume',
  },
  {
    name: 'Music',
    value: 'music',
    manual: true,
    title: 'Music',
    apiAlias: 'music',
    id: 'music',
  },
  {
    name: 'Musical Recording',
    value: 'musical-recording',
    manual: false,
    title: 'a Musical Recording',
    apiAlias: 'musicalrecording',
    id: 'musical-recording',
  },
  {
    name: 'Newsgroup',
    value: 'newsgroup',
    manual: true,
    title: 'a Newsgroup',
    apiAlias: 'newsgroup',
    id: 'newsgroup',
  },
  {
    name: 'Newsletter',
    value: 'newsletter',
    manual: true,
    title: 'a Newsletter',
    apiAlias: 'newsletter',
    id: 'newsletter',
  },
  {
    name: 'Painting',
    value: 'painting',
    manual: true,
    title: 'a Painting',
    apiAlias: 'painting',
    id: 'painting',
  },
  {
    name: 'Pamphlet',
    value: 'pamphlet',
    manual: true,
    title: 'a Pamphlet',
    apiAlias: 'pamphlet',
    id: 'pamphlet',
  },
  {
    name: 'Patent',
    value: 'patent',
    manual: true,
    title: 'a Patent',
    apiAlias: 'patent',
    id: 'patent',
  },
  {
    name: 'Performance',
    value: 'performance',
    manual: true,
    title: 'a Performance',
    apiAlias: 'performance',
    id: 'performance',
  },
  {
    name: 'Photo',
    value: 'photo',
    manual: true,
    title: 'a Photo',
    apiAlias: 'photo',
    id: 'photo',
  },
  {
    name: 'Press Release',
    value: 'press',
    manual: true,
    title: 'a Press Release',
    apiAlias: 'press',
    id: 'press',
  },
  {
    name: 'Raw Data',
    value: 'raw-data',
    manual: true,
    title: 'Raw Data',
    apiAlias: 'rawdata',
    id: 'raw-data',
  },
  {
    name: 'Report',
    value: 'report',
    manual: true,
    title: 'a Report',
    apiAlias: 'report',
    id: 'report',
  },
  {
    name: 'Reprinted Work',
    value: 'collection',
    manual: true,
    title: 'Reprint',
    apiAlias: 'collection',
    id: 'collection',
  },
  {
    name: 'Review',
    value: 'review',
    manual: true,
    title: 'a Review',
    apiAlias: 'review',
    id: 'review',
  },
  {
    name: 'Scholarly Project',
    value: 'scholarly-project',
    manual: true,
    title: 'a Scholarly Project',
    apiAlias: 'scholarlyproject',
    id: 'scholarly-project',
  },
  {
    name: 'Software',
    value: 'software',
    manual: false,
    title: 'Software',
    apiAlias: 'software',
    id: 'software',
  },
  {
    name: 'TV/Radio',
    value: 'tv',
    manual: true,
    apiAlias: 'tv',
    title: 'a TV/Radio Show',
    id: 'tv',
  },
  {
    name: 'Thesis',
    value: 'thesis',
    manual: false,
    title: 'a Thesis',
    apiAlias: 'thesis',
    id: 'thesis',
  },
  {
    name: 'Write/paste citation',
    value: 'custom',
    manual: true,
    title: 'a Custom Citation',
    apiAlias: 'custom',
    id: 'custom',
  },
]

export default sourceTypes
